import { getRuntimeConfig } from '../config/runtimeConfig';

export const LOGIN_APP_PATH: string = '/login';

export const ACCESSIBILITY_STATEMENT_PATH: string = '/accessibility-statement';

export const FORM_PATH: string = '/form';

export const SEND_OTP_PATH = '/send-otp';
export const VERIFY_OTP_PATH = '/verify-otp';
export const CHECK_IF_USER_LOCKED_PATH: string = '/verify-locked';
export const GET_FORM_DATA_PATH: string = '/fetch-form';
export const UPDATE_FORM_DATA_PATH: string = '/update-form';
export const PREVIEW_PATH: string = '/preview';

export const V2_PATH: string = '/v2';

export function getServerUrl(): string {
  return getRuntimeConfig().REACT_APP_SERVER_URL;
}

export function getSendOtpServerUrl(): string {
  return `${getServerUrl()}${V2_PATH}${SEND_OTP_PATH}`;
}

export function getVerifyOtpServerUrl(): string {
  return `${getServerUrl()}${V2_PATH}${VERIFY_OTP_PATH}`;
}

export function getCheckIfUserLockedServerUrl(): string {
  return `${getServerUrl()}${V2_PATH}${CHECK_IF_USER_LOCKED_PATH}`;
}

export function getFormDataServerUrl(): string {
  return `${getServerUrl()}${V2_PATH}${GET_FORM_DATA_PATH}`;
}

export function getUpdateFormDataServerUrl(): string {
  return `${getServerUrl()}${V2_PATH}${UPDATE_FORM_DATA_PATH}`;
}

export function getPreviewServerUrl(): string {
  return `${getServerUrl()}${V2_PATH}${PREVIEW_PATH}`;
}

export const SESSION_ID_COOKIE_NAME: string = 'sessionId';
export const LANGUAGE_ITEM_NAME: string = 'languageStorageItem';

export const MAX_VERIFY_OTP_ERROR = 'max verify otp attempts reached';
export const MAX_SEND_OTP_ERROR = 'max send otp attempts reached';

export const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
export const INPUT_TEXT_SUSPICIOUS_PATTERN = /on\w+\s*=\s*["']?|<[^>]+>|javascript:/i;

export const NUMBER_FIELD_TYPE = 'number';
export const DATETIME_LOCAL_FIELD_TYPE = 'datetime-local';
export const DATE_FIELD_TYPE = 'date';
export const DATETIME_FIELD_TYPE = 'datetime'; // legacy: old console saved "datetime" instead of "date"
